import { Box, Link, Tooltip } from "@material-ui/core";
import { ElementType, useContext } from "react";
import { LoginUserContext } from "../../providers/LoginUserProvider";
import { TAppMember } from "../../types/TAppMember";

const MAX_LENGTH = 10;
type MessageBoardNicknameProps = {
  nickname: string;
  redirectTo?: string;
  className?: string;
  component?: ElementType;
  uid?: string;
};

const MessageBoardNickname = (props: MessageBoardNicknameProps) => {
  const {
    uid = "",
    nickname = "",
    redirectTo = undefined,
    className = "",
    component = undefined,
  } = props ?? {};

  const { member = {} } = useContext(LoginUserContext);
  const { uid: currentLoginUserUid = "" } = member as TAppMember;

  if (!nickname) {
    return null;
  }

  const isCurrentUser = uid === currentLoginUserUid;
  const shouldTruncate = nickname.length > MAX_LENGTH;
  const truncateNickname = shouldTruncate
    ? nickname.slice(0, MAX_LENGTH) + "..."
    : nickname;

  const renderNickname = () => {
    if (component) {
      return (
        <Box
          component={component}
          className={className}
          style={{ color: "black" }}
        >
          {truncateNickname}
        </Box>
      );
    }

    if (isCurrentUser) {
      return (
        <Link href="/mypage" className={className} style={{ color: "black" }}>
          {truncateNickname}
        </Link>
      );
    }
    return (
      <Link href={redirectTo} className={className} style={{ color: "black" }}>
        {truncateNickname}
      </Link>
    );
  };

  if (!shouldTruncate) {
    return renderNickname();
  }

  return (
    <Tooltip placement="top" arrow title={nickname}>
      {renderNickname()}
    </Tooltip>
  );
};

export default MessageBoardNickname;
